import {Greeting} from "types/Greeting";
import {dateTime} from "services/date";

/**
 * Transform the given article by deserializing object properties
 *
 * @internal
 * @param article
 */
export default function deserializeGreeting(article: any): Greeting {
    article.enabled_at = dateTime(article.enabled_at)
    article.created_at = dateTime(article.created_at)
    article.updated_at = dateTime(article.updated_at)

    return article;
}